import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import MDBox from "../../MDBox";
import MDInput from "../../MDInput";
import HearingIcon from "@mui/icons-material/Hearing";
import ValidationHint from "../../GenericQuiz/validation-hint.js";

function WordQuestion({ question, answer, onAnswerChange, valid, validAnswer, submit }) {
  const readWord = useCallback(() => {
    if (question.word) {
      //Read the word
      let utterance = new SpeechSynthesisUtterance(question.word);
      speechSynthesis.speak(utterance);
    }
  }, [question.word]);

  useEffect(readWord, [question.word]);

  return (
    <>
      <MDBox sx={{ fontSize: "2rem", mb: 2, color: "#577ab4", lineHeight: "1" }}>
        <MDBox
          sx={{ fontWeight: "bold", cursor: "pointer", userSelect: "none" }}
          component="span"
          onClick={readWord}
        >
          <HearingIcon /> Écoute
        </MDBox>{" "}
        bien le mot suivant et écris le correctement ci-dessous :
      </MDBox>
      <MDBox display="flex" alignItems="center" sx={{ fontSize: "2.2rem", "& > *": { mr: 1 } }}>
        <MDInput
          type="text"
          name="answer"
          value={answer || answer === 0 ? answer : ""}
          onChange={onAnswerChange}
          onKeyUp={(e) => {
            if (e.keyCode === 13) {
              submit();
            }
          }}
          readOnly={valid > 0}
          success={valid === 1}
          error={valid === 2 || valid < 0}
          focused={true}
          sx={{
            "& .MuiInputBase-input": { fontSize: "2.2rem", width: 250, textAlign: "center" },
          }}
        />
      </MDBox>
      <ValidationHint valid={valid} validAnswer={validAnswer} />
    </>
  );
}
WordQuestion.propTypes = {
  question: PropTypes.object,
  answer: PropTypes.string,
  onAnswerChange: PropTypes.func,
  valid: PropTypes.number,
  validAnswer: PropTypes.string,
  submit: PropTypes.func,
};

export default WordQuestion;
